import React, { useState } from 'react';
import { Box, Button, CircularProgress, TextField, Tooltip, Typography } from "@mui/material";
import { MuiTelInput } from 'mui-tel-input';
import InfoIcon from '@mui/icons-material/Info';

export function EditableField({
  isLoading,
  label,
  onSubmit,
  tooltip,
  type,
  value
}: {
  isLoading: boolean;
  label: string;
  onSubmit: (value: string) => void;
  tooltip?: string
  type?: 'phone' | string
  value?: string;
}) {
  const [editing, setEditing] = useState<boolean>(false);
  const [newValue, setNewValue] = useState<string>('');
  return (
    <Box
      marginY={2}
    >
      <Typography
        fontWeight={500}
        lineHeight={1}
      >{label}{tooltip &&
        <Tooltip
          title={tooltip}>
          <InfoIcon
            fontSize='small'
            style={{
              position: 'relative',
              top: 4
            }}
          />
        </Tooltip>
        }</Typography>
      <Box
        display='flex'
        alignItems='center'
      >
        {!editing && <>
          <Typography
          >{value}</Typography>
          <Button
            onClick={() => setEditing(true)}
          >Edit</Button>
        </>}
        {editing && <>
          {type === 'phone'
            ? <MuiTelInput
              onChange={value => setNewValue(value)}
              placeholder={value}
              size='small'
              value={newValue}
            />
            : <TextField
              onChange={e => setNewValue(e.target.value)}
              placeholder={value}
              size='small'
            />}
          <Box
            display='flex'
            alignItems='center'
          >
            <Button
              disabled={isLoading}
              onClick={() => {
                onSubmit(newValue)
                setEditing(false)
              }}
              style={{
                marginLeft: 2,
                marginRight: 2
              }}
              variant='contained'
            >{isLoading
              ? <CircularProgress
                size={25} />
              : 'Save'}</Button>
            <Button
              onClick={() => setEditing(false)}
              color='secondary'
              variant='contained'
            >Cancel</Button>
          </Box>
        </>}
      </Box>
    </Box>
  );
}
